import { ResourceRoleSubject } from '../types';

export default function isEqualResourceRoleSubject(
  r1: ResourceRoleSubject,
  r2: ResourceRoleSubject
) {
  return r1.subjectType === r2.subjectType && r1.subjectId === r2.subjectId;
}
